<template>
  <DBox
    :id="'cmp-distribution-shop_grouops-sidewindow-shops'"
    :addButton="false"
    :addLink="true"
    :addLinkLabel="`${$t('add')} ${$t('shop')}`"
    @add_click="onAddShops"
  >
    <!-- :addLinkLabel="`${$t('add')} ${'new'} ${'tracks'}`" -->
    <NTable
      class="dbox1"
      id="distribution-shop_grouops-sidewindow-shops-list"
      :config="tableConfig"
      :headers="headers"
      :items="selectedShop_groupDetails.related_shops || []"
      :showNoItems="false"
    >
      <template v-slot:item="{ item, tdcon }">
        <tr>
          <td v-bind="tdcon('shops')">
            <span
              @click.stop="e => onSelectShop(item)"
              class="txtov ut-link ut-text-accent5"
              :title="item['shop']"
            >
              {{ item["shop"] }}
            </span>
          </td>
          <td v-bind="tdcon('channel')">
            <span class="txtov" :title="item['channel']">
              {{ item["channel"] }}
            </span>
          </td>
          <td v-bind="tdcon('options')">
            <img
              src="static/icons/delete.svg"
              @click.stop="e => onDeleteShops(item)"
              class="dt-icon v5 s1 ut-center"
              alt
            />
          </td>
        </tr>
      </template>
    </NTable>
  </DBox>
</template>

<script>
import DBox from "@dtplugins/dbox/dbox";
import NTable from "@/plugins/datatable/datatable";
import {
  createNTableConfig,
  createTableHeader
} from "../../../../plugins/datatable";
import { confirmDelete } from "../../../../dt-plugins/confirmation/confirmation-common";
import { distributionShopListLDTRoutes } from "../../router/routes";

export default {
  components: {
    DBox,
    NTable
  },
  props: ["selectedShop_groupDetails"],
  computed: {
    tableConfig: function() {
      return createNTableConfig({
        headerStyle: 3,
        fullHeight: true
      });
    },
    headers: function() {
      return [
        createTableHeader("shops"),
        createTableHeader("channel"),
        createTableHeader("options", { text: false, mw: 30, ta: "center" })
      ];
    },
    contract_id: function() {
      return this.$route.params.contract_id;
    }
  },
  methods: {
    onSelectShop: function(selectedShop) {
      console.log("onSelectShop digital", selectedShop);
      this.$router.push({
        name: distributionShopListLDTRoutes.names.tab,
        params: {
          shop_id: selectedShop.shop_id,
          tab: "overview"
        }
      });

      // if (selectedShop.channel == "digital") {
      //   console.log("onSelectShop digital", selectedShop);

      //   this.$router.push({
      //     name: distributionShopListLDTRoutes.names.tab,
      //     params: {
      //       shop_id: selectedShop.shop_id,
      //       tab: "overview"
      //     }
      //   });
      // } else if (selectedShop.channel == "physical") {
      //   console.log("onSelectShop special ", selectedShop);
      // }
      // this.$emit("selected", selectedShopGroup.release_id);
    },

    onAddShops: function() {
      this.$emit("add_click", true);
    },

    onDeleteShops: async function(item) {
      console.log("onDeleteShops ", item);
      const confirmationResult = await confirmDelete(
        "shop relation",
        item.shop
      );
      if (confirmationResult === "OK") {
        this.$emit("deleted", item);
      }
    }
  }
};
</script>
